import { Button } from '@/components/UI/Common/Button';
import { CheckButton } from '@/components/UI/Common/CheckButton';
import { SvgIcon } from '@/components/UI/Common/SvgIcon';
import { IApplicationGroup } from '@/types/appliction';
import classnames from 'classnames';
import { useEffect, useRef } from 'react';
interface Props {
  className?: string;
  selectedFilters: string[];
  groups?: IApplicationGroup[];
  onToggleFilter: (id: string) => void;
  onClearFilter?: () => void;
}

export const UserApplicationFilter: React.FC<Props> = ({
  groups = [],
  className,
  onToggleFilter,
  selectedFilters,
  onClearFilter,
}) => {
  const scrollerRef = useRef<HTMLDivElement>(null);

  useEffect(() => {
    const el = scrollerRef.current;
    if (!el) return;

    const onWheel = (event: WheelEvent) => {
      const maxScroll = el.scrollWidth - el.clientWidth;
      if (maxScroll <= 0 || Math.abs(event.deltaX) > Math.abs(event.deltaY)) return;

      const delta = event.deltaMode === 1 ? event.deltaY * 16 : event.deltaY;
      const next = Math.max(0, Math.min(maxScroll, el.scrollLeft + delta));
      if (next === el.scrollLeft) return;

      event.preventDefault();
      el.scrollLeft = next;
    };

    el.addEventListener('wheel', onWheel, { passive: false });
    return () => el.removeEventListener('wheel', onWheel);
  }, []);

  const handleSelect = (groupId: string) => {
    onToggleFilter(groupId);
  };

  return (
    <div
      ref={scrollerRef}
      className={classnames(
        className,
        'min-w-0 overflow-x-auto overflow-y-hidden overscroll-x-contain pt-0 pb-4 lg:py-8 [scrollbar-width:none] [-ms-overflow-style:none] [&::-webkit-scrollbar]:hidden',
      )}
    >
      <div className="flex w-max flex-nowrap gap-2 px-4 lg:px-8">
        {!!groups?.length &&
          groups.map((group) => (
            <CheckButton
              key={group.id}
              isActive={selectedFilters.includes(group.id)}
              onClick={() => handleSelect(group.id)}
            >
              {group.title}
            </CheckButton>
          ))}
        {!!groups.length && (
          <Button onClick={onClearFilter} variant="secondary">
            <SvgIcon name="close" size={10} />
          </Button>
        )}
      </div>
    </div>
  );
};
